<template>
  <div>
    <div
      class="tags-list__wrapper"
      :class="{ ['single']: _single, ['expanded']: isExpanded }"
      :ref="rootRefName"
    >
      <VTag
        v-for="tag in tags"
        :key="tag.key"
        :label="tag.label"
        :ref="tag.label"
        :withDelete="false"
      />
      <div v-if="!tags || !tags.length">No tags</div>
    </div>
    <div
      v-if="hiddenTags.length || this.isExpanded"
      @click="_expand"
      class="expand"
    >
      Show {{ isExpanded ? "less" : `${hiddenTags.length} more` }}
      <i :class="_icon"></i>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

// components
import VTag from "@/components/VTag";

//mixins
import withIntersectionObserver from "@/mixins/withIntersectionObserver";

export default Vue.component("VTagsExpandableList", {
  props: {
    tags: VueTypes.array.isRequired,
    identifier: VueTypes.string,
    onExpand: VueTypes.func,
    onceAtTime: VueTypes.bool.def(false),
    expanded: VueTypes.bool.def(false)
  },

  components: {
    VTag
  },

  mixins: [withIntersectionObserver("tagsLabels", "hiddenTags", "tagsList")],

  data() {
    return {
      hiddenTags: [],
      isExpanded: false,
      rootRefName: "tagsList"
    };
  },

  methods: {
    _expand(e) {
      e.stopPropagation();
      this.onExpand && this.onExpand(this.identifier);
      this.isExpanded = !this.isExpanded;
    }
  },

  computed: {
    _icon() {
      return `far fa-chevron-${this.isExpanded ? "up" : "down"}`;
    },

    _single() {
      return this.tags && this.tags.length === 1;
    },

    tagsLabels() {
      if (this.tags && this.tags.length) {
        return this.tags.map(tag => tag.label);
      }
      return [];
    }
  }
});
</script>

<style lang="scss" scoped>
.tags-list__wrapper {
  position: relative;
  height: 28px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;

  &.expanded {
    height: auto;
  }

  /deep/ .v-tag__wrapper {
    &:last-child {
      margin-right: 0;
    }
  }
}
.expand {
  margin-top: 13px;
  font-family: "Lato-Regular", Arial, sans-serif;
  font-weight: bold;
  color: $primary-grey;
  font-size: 12px;
  margin-bottom: 3px;
  transition: color 0.15ms linear;
  padding: 2px;

  &:hover {
    color: $primary-color;
  }

  i {
    margin-left: 5px;
  }
}
</style>

<style lang="scss">
.single {
  .v-tag__wrapper {
    margin: 0;
  }
}
</style>
